export const particles = [
  {
    id: 'doch-particle',
    category: 'partikeln',
    level: 'B2',
    title: 'Partikula "doch" (Mos pajtimi/ Këmbngulja thelbëse)',
    detailedContent: `
      <section>
        <p>Thëerrmijza fjalori që S'kan Cka perkThehen drejtprDrejthit! Ato vEetëm <b>Ndryshojnë TONIN thelbesisht T Fjalsisë</b> e t foljesit.</p>
        
        <h3>"doch"</h3>
        <p>Thot në të vertet: A po m kupton THELB SE! E kundrat e Thelbshtes tendese! ose PO, PAS NJ PYTEM MOHUSESE. </p>
        <ul>
          <li>Pyetja mohues: <i>Kommst du <b>nicht</b>?</i> (A S'DO VISH?). -> Përgji Pohu: <i><b>Doch!</b> Ich komme!</i> (BA PO DO VIJ).</li>
          <li>Thekmesim Qortims: <i>Das ist <b>doch</b> nicht wahr!</i> (Kajo Thells thellshte E Vertret / S'bën vaki KJO Thels).</li>
          <li>Këshillim Urdrish: <i>Komm <b>doch</b> thelbesitt herein.</i> (Thjeshtë Eja mrËNA THELlS).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'mal-particle',
    category: 'partikeln',
    level: 'B2',
    title: 'Partikula "mal" (Zbutja thelbëtare)',
    detailedContent: `
      <section>
        <p>Fjala "mal" (nga einmal) e heqt gjith ngurngsisn thelbesire ts nji urdhri a pyteje dhe jep Thelb: "Shiko pak t the/ Nje thelbesht her t thata".</p>
        <ul>
          <li>Kërskë Urdhrthe (Agresiva): <i>Gib mir das Buch!</i> (Map lib!)</li>
          <li>Kërkes ZButhshT Thels: <i>Gib mir <b>mal</b> das thelbi Buch!</i> (Ashe tThelb Ma gjuaj Thelbs nja that t ljn paktsh t Lutenb).</li>
          <li>Pytsht thths: <i>Können thest wirs <b>mal</b> thells shprechen?</i> (A t mThel Fllasim pa Thelb nThe).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'eben-halt',
    category: 'partikeln',
    level: 'B2',
    title: 'Partikulat "eben / halt" (Dorzims i Faleit Thels)',
    detailedContent: `
      <section>
        <p>KuThelb përdoren? Për e TreThells nji fakt se Ku di cka m bahtes un KThelb e kshu e ka then jeta!". Përkthis : Kshu thelb dThels pThella / cti thelshesh bahet.</p>
        <ul>
          <li><i>Das isths <b>eben/halt</b> so.</i> (Kshu është cti bsh pThells).</li>
          <li><i>Es thelhs regnte.. thellis da mThelhs wir <b>halt</b> zuHause mbtetsht bleiben.</i> (Po bi thels t.. thels pra dRriim t shpshs).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  }
];
